// Audio and video recording suite
import type { SynthEngine } from './synth';

let mediaRecorder: MediaRecorder | null = null;
let recorderChunks: Blob[] = [];
let isRecording = false;
let recordStartTime = 0;
let recordInterval: ReturnType<typeof setInterval> | null = null;

function updateRecordTimer() {
  const elapsed = Math.floor((Date.now() - recordStartTime) / 1000);
  const m = String(Math.floor(elapsed / 60)).padStart(2, '0');
  const s = String(elapsed % 60).padStart(2, '0');
  const timerVal = document.getElementById('timerVal');
  if (timerVal) timerVal.textContent = `${m}:${s}`;
}

export async function toggleRecording(synth: SynthEngine): Promise<void> {
  const btn = document.getElementById('btnRec');
  const timerDisplay = document.getElementById('recTimer');

  if (!isRecording) {
    synth.init();
    try {
      const canvas = document.getElementById('c') as HTMLCanvasElement;
      const videoStream = canvas.captureStream(60);
      const audioStream = synth.streamDest!.stream;

      const combinedStream = new MediaStream();
      videoStream.getVideoTracks().forEach(track => combinedStream.addTrack(track));
      audioStream.getAudioTracks().forEach(track => combinedStream.addTrack(track));

      let options: MediaRecorderOptions = {
        mimeType: 'video/webm;codecs=vp9',
        videoBitsPerSecond: 5000000
      };

      if (!MediaRecorder.isTypeSupported(options.mimeType!)) {
        options = { mimeType: 'video/webm', videoBitsPerSecond: 5000000 };
      }

      mediaRecorder = new MediaRecorder(combinedStream, options);

      recorderChunks = [];
      mediaRecorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          recorderChunks.push(e.data);
        }
      };

      mediaRecorder.onstop = () => {
        if (recordInterval) clearInterval(recordInterval);
        if (timerDisplay) timerDisplay.style.display = 'none';

        const blob = new Blob(recorderChunks, { type: 'video/webm' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `synesthesia_nft_session_${Date.now()}.webm`;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 100);
      };

      mediaRecorder.start();
      isRecording = true;
      recordStartTime = Date.now();
      const timerVal = document.getElementById('timerVal');
      if (timerVal) timerVal.textContent = "00:00";
      if (timerDisplay) timerDisplay.style.display = 'flex';
      recordInterval = setInterval(updateRecordTimer, 1000);

      if (btn) {
        btn.classList.add('recording');
        btn.textContent = '⏹ STOP';
      }
    } catch (err) {
      console.error("Recording initialization failed:", err);
    }
  } else {
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop();
    }
    isRecording = false;
    if (btn) {
      btn.classList.remove('recording');
      btn.textContent = '🔴 REC';
    }
  }
}

let snapRequested = false;

export function requestSnap() {
  snapRequested = true;
}

export function checkSnap() {
  if (snapRequested) {
    snapRequested = false;
    const canvas = document.getElementById('c') as HTMLCanvasElement;
    const dataURL = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = dataURL;
    a.download = `synesthesia_nft_still_${Date.now()}.png`;
    a.click();
  }
}